import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo } from "react";
import { useSelector } from "react-redux";
import { BoardStats } from "~/components/v2/components/board/shared/BoardStats";
import { usePublicBoardStats } from "~/components/v2/hooks/queries/usePublicBoardsStats";
import { formatBoardStats } from "~/components/v2/utils/boards/formatBoardStats";
import { useIsFlattenedView } from "~/hooks/search/useIsFlattenedView";
import { centralizedBoardIdSelector } from "~/store/centralizedBoard/selectors";
export const PublicBoardStats = /*#__PURE__*/ memo(()=>{
    const boardId = useSelector(centralizedBoardIdSelector);
    const { isFlattenedView } = useIsFlattenedView();
    const { shortId } = useShortIdContext();
    const { data: boardStats } = usePublicBoardStats({
        boardId: boardId || "",
        shortId,
        includeDescendants: isFlattenedView
    });
    if (!boardStats) return null;
    return /*#__PURE__*/ _jsx(BoardStats, {
        children: formatBoardStats(boardStats).join(" \xb7 ")
    });
});
PublicBoardStats.displayName = "PublicBoardStats";
